import { IconButton } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import LinkButton from 'components/LinkButton';
import CloseIcon from 'components/icons/CloseIcon';

import useTranslation from './hooks/useTranslation';

import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FloatingResourceContainerFooter: FunctionComponent<Props> = ({
    onBack,
    onClose,
    resource
}) => {
    const { FORM_SELECTION, NEW_FORM_LINK_TEXT } = useTranslation();

    const linkText = resource ? NEW_FORM_LINK_TEXT(resource) : FORM_SELECTION;

    return (
        <Grid className={styles.grid}>
            <LinkButton isDisabled={!resource} onClick={onBack} text={linkText} />

            <IconButton onClick={onClose}>
                <CloseIcon className={styles.closeIcon} />
            </IconButton>
        </Grid>
    );
};

export default FloatingResourceContainerFooter;
